/**
 * Created by sswaminathan on 1/9/23
 * File: BackBoneRegionSelection
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { capitalize } from 'lodash'
import { CloseIcon } from '@panwds/icons'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback } from 'react'
const BackBoneRegionSelection = ({ value, callback }) => {

  const onDelete = useCallback(() => {
    callback(value)
  }, [callback, value])

  return <div className='tw-flex tw-flex-row tw-flex-1'>
    <div className='tw-flex tw-flex-1'>{capitalize(value.region)}</div>
    <div className='tw-flex tw-align-right' onClick={onDelete}>
      <CloseIcon size='sm' />
    </div>
  </div>
}

BackBoneRegionSelection.propTypes = {}
export default BackBoneRegionSelection
